export const KEY_GET_REPORTS_ASSESSMENTS = 'get.reports-assessments.call';
export const KEY_GET_REPORTS_TRAININGS = 'get.reports-trainings.call';
export const KEY_GET_REPORT_ASSESSMENT_EXPORT = 'get.report-assessment-export.call';
export const KEY_GET_REPORT_TRAINING_EXPORT = 'get.report-training-export.call';
